import React from "react";
import { Heart, Compass, Flower2 } from "lucide-react";

const ACRONYM = [
    {
        letter: "H",
        word: "Healing",
        icon: Heart,
        copy: "Tending the quiet wounds — the ones no one saw, the ones you carried in silence — with grace and the Word.",
    },
    {
        letter: "E",
        word: "Evolution",
        icon: Compass,
        copy: "Becoming is not a moment, it's a movement. We honor the soft surrender and the bold step forward.",
    },
    {
        letter: "R",
        word: "Rediscovery",
        icon: Flower2,
        copy: "Returning to the woman beneath the noise — before the shrinking, before the self-abandonment — already whole.",
    },
];

export const About = () => {
    return (
        <section id="about" data-testid="about-section" className="relative py-24 md:py-36 overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="grid grid-cols-12 gap-10 items-start">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="eyebrow text-gold-deep mb-6">About the show</div>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-lilac-900 max-w-md">
                            A safe place
                            <br />
                            for the woman
                            <br />
                            <span className="italic gold-text">becoming.</span>
                        </h2>
                        <p className="mt-8 text-lilac-700 leading-relaxed max-w-md">
                            Becoming H.E.R. is a faith-centered podcast hosted by Coach Melissa — a
                            Certified Life &amp; Empowerment Coach — for women ready to heal, grow, and
                            walk boldly in the woman God created them to be.
                        </p>
                        <p className="mt-5 text-lilac-700 leading-relaxed max-w-md">
                            Real conversations. Raw healing. Kingdom transformation.
                        </p>
                        <a
                            href="#episodes"
                            data-testid="about-listen-link"
                            className="inline-flex items-center gap-2 mt-8 font-display italic text-lilac-900 underline-offset-8 underline decoration-gold/60 hover:decoration-gold"
                        >
                            Begin with Episode 01 →
                        </a>
                    </div>

                    <div className="col-span-12 lg:col-span-7">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                            {ACRONYM.map((a, i) => (
                                <div
                                    key={a.letter}
                                    className={`relative rounded-3xl border border-border bg-white p-7 shadow-[0_8px_32px_rgba(43,29,53,0.04)] ${
                                        i === 1 ? "md:translate-y-8" : ""
                                    }`}
                                    data-testid={`about-card-${a.word.toLowerCase()}`}
                                >
                                    <div className="flex items-baseline justify-between">
                                        <span className="font-display text-7xl gold-text leading-none">
                                            {a.letter}
                                        </span>
                                        <a.icon className="w-5 h-5 text-gold-deep" />
                                    </div>
                                    <div className="mt-6 eyebrow text-lilac-700">{a.word}</div>
                                    <p className="mt-3 text-sm text-lilac-700 leading-relaxed">
                                        {a.copy}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
                            {[
                                { k: "Pillars", v: "4" },
                                { k: "Episodes", v: "Soon" },
                                { k: "Hosted by", v: "Coach Melissa" },
                                { k: "Tone", v: "Faith-Led" },
                            ].map((s) => (
                                <div
                                    key={s.k}
                                    className="rounded-2xl bg-lilac-100/60 p-5 border border-lilac-200/70"
                                >
                                    <div className="font-display text-3xl text-lilac-900">{s.v}</div>
                                    <div className="eyebrow mt-1 text-lilac-700">{s.k}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
